import cloneDeep from 'lodash/cloneDeep'

export const WAIT_CONFIRM = 'WaitConfirm'
export const WAIT_QUTER_SENT = 'WaitOuterSent'
export const SENT = 'Sent'
export const QUESTION = 'Question'
export const CANCELLED = 'Cancelled'

export const SETTLED_LABEL = '已结算'

export const NONE = 'None'
export const WAIT_PAY = 'WaitPay'
export const WAIT_DELIVER = 'WaitDeliver'
export const WAIT_F_CONFIRM = 'WaitFConfirm'
export const DELIVERING = 'Delivering'
export const OUTER_SENT = 'OuterSent'
export const MERGED = 'Merged'
export const REPLACED = 'Replaced'
export const SPLIT = 'Split'
export const DISABLED = 'Disabled'
export const DELETE = 'Delete'
export const SENT_CANCELLED = 'SentCancelled'
export const LOCK = 'Lock'

export const ORDER_STATUS_MAP = {
    [WAIT_CONFIRM]: '待审核推单',
    [WAIT_QUTER_SENT]: '待发货',
    [SENT]: '已发货',
    [QUESTION]: '异常',
    [CANCELLED]: '已取消',
    [NONE]: '无状态',
    [WAIT_PAY]: '待付款',
    [WAIT_DELIVER]: '可发货',
    [WAIT_F_CONFIRM]: '等待财务审核',
    [DELIVERING]: '发货中',
    [OUTER_SENT]: '外仓发货',
    [MERGED]: '被合并',
    [REPLACED]: '',
    [SPLIT]: '被拆分',
    [DISABLED]: '失效',
    [DELETE]: '删除',
    [SENT_CANCELLED]: '发货取消',
    [LOCK]: '不允许发货',
}

export const ORDER_STATUS_LIST = [
    WAIT_CONFIRM,
    QUESTION,
    WAIT_PAY,
    WAIT_QUTER_SENT,
    SENT,
    MERGED,
    SPLIT,
    CANCELLED,
].map(_ => ({
    value: _,
    label: ORDER_STATUS_MAP[_],
}))

export const ORDER_STATUS_VERTICAL_LIST = [
    WAIT_CONFIRM,
    QUESTION,
    WAIT_PAY,
    WAIT_QUTER_SENT,
    SENT,
    MERGED,
    SPLIT,
    CANCELLED,
].map(_ => ({
    value: _,
    label: ORDER_STATUS_MAP[_],
}))

const STATUS_WIDTH_MAP = {
    [WAIT_PAY]: 111,
    [WAIT_CONFIRM]: 228,
    [WAIT_QUTER_SENT]: 111,
    [SENT]: 111,
    [QUESTION]: 228,
    [MERGED]: 112,
    [SPLIT]: 111,
    [CANCELLED]: 111,
}

export const GENERAL_ORDER_STATUS_LIST = [
    WAIT_PAY,
    WAIT_CONFIRM,
    DELIVERING,
    SENT,
    QUESTION,
    CANCELLED,
    MERGED,
    SPLIT,
].map(v => {
    return {
        value: v,
        label: ORDER_STATUS_MAP[v],
    }
})

export const transToLabel = key => ORDER_STATUS_MAP[key]

// 代发订单和采购代发订单，文案为 ‘待推单’；普通订单和自发订单文案为 ‘待审核’， 所以这里根据路由区分
export const getOrderStatusMap = orderType => {
    const map = cloneDeep(ORDER_STATUS_MAP)
    map[WAIT_CONFIRM] = orderType?.includes('分销Plus') ? '待推单' : '待审核'

    return map
}

export const getDistributeOrderStatusList = sort => {
    // const map = getOrderStatusMap()

    const res = (sort === 'vertical' ? ORDER_STATUS_VERTICAL_LIST : ORDER_STATUS_LIST).map(v => ({
        ...v,
        label: ORDER_STATUS_MAP[v.value],
        style: {
            width: `${STATUS_WIDTH_MAP[v.value]}px`,
        },
    }))

    return res
}

// 订单类型（orderTypeEnum）
export const DIS = 'DIS' // 代发订单
export const SELF = 'SELF' // 自发订单
export const INCLUDE_SUP = 'INCLUDE_SUP' // 供销订单
export const ALL = 'ALL' // 全部订单

// 默认的筛选的订单类型
export const INIT_ORDER_STATUS = [
    WAIT_PAY,
    WAIT_CONFIRM,
    WAIT_QUTER_SENT,
    SENT,
    QUESTION,
    DELIVERING,
    WAIT_F_CONFIRM,
    OUTER_SENT,
]
export const INIT_ALL_ORDER_STATUS = []
export const INIT_DOUBLE_ADDRESS_ORDER_STATUS = [WAIT_CONFIRM, WAIT_PAY, WAIT_QUTER_SENT, QUESTION, DELIVERING] // 双地址订单查询需要的订单状态
